// JOBE-0044.14: skeleton-loading variant. 8 skeleton rows of the 3-line
// shape per umbrella R9. No shimmer in v1 — JOBE-0044.7 adds animation.
//
// Renders synchronously on the first render so the page is never "blank
// then populated" per R11.

export function SkeletonState({ rows = 8 }) {
  const count = Math.max(1, rows | 0);
  return (
    <ul
      className="library-table-body library-table-skeleton library-state-skeleton"
      aria-busy="true"
      aria-label="Loading library"
      data-state="skeleton"
    >
      {Array.from({ length: count }, (_, i) => (
        <li
          key={i}
          className="library-row library-row-skeleton"
          role="presentation"
        >
          <span className="skel-line skel-w-80" />
          <span className="skel-line skel-w-60" />
          <span className="skel-line skel-w-70" />
        </li>
      ))}
    </ul>
  );
}
